import React from 'react';

/** Bootstrap Components */
import { Card, Container, Row, Col } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

/** Custom CSS */
import '../css/styles.css';

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';
import SideMenuComponent from './sidemenu';

import { AUTH_URL, LOG_URL, PASSWD_DAYS } from '../utils/constants'

class HomeComponent extends React.Component {
	constructor(props) {
		super(props);
		var cf = '';
		var year = new Date().getFullYear();
		if (new Date().getMonth() >= 3)
			cf = year + '-' + (year + 1);
		else
			cf = (year - 1) + '-' + year;
		localStorage.setItem('fin_year', cf);

		this.state = {
			items: [],
			isLoaded: true,
			last_updated: '',
			last_login: ''
		}
	}
	componentDidMount() {
		fetch(AUTH_URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + localStorage.getItem('token')
			}
		})
			.then(res => res.json())
			.then(user => {
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Authorization: 'Bearer' + localStorage.getItem('token') },
					body: JSON.stringify({ userid: localStorage.getItem('user') })
				};

				fetch(LOG_URL, requestOptions)
					.then(res => res.json())
					.then(
						(result) => {
							this.setState({
								isLoaded: true,
								items: result.DATA,
								last_updated: result.PASSWD_CHANGE[0].last_updated,
								last_login: result.LAST_LOGIN[0]
							});
							localStorage.setItem('days', result.PASSWD_CHANGE[0].last_updated);
						},
						(error) => {
							this.setState({
								isLoaded: true,
								error
							});
						}
					)
			},
				(error) => {
					alert('Session expired. Redirecting...');
					this.props.history("/login");
					return false;
				}
			);
	}
	render() {
		const { items, isLoaded, last_updated, last_login } = this.state;
		if (last_updated > PASSWD_DAYS) {
			this.props.history("/changepwd");
		}

		if (!isLoaded) {
			return (<div class="simple-shape two"></div>);
		}
		else {
			return (
				<div>
					<NavbarComponent />
					<nav className="sticky"></nav>
					<div className="App-common main">
						<Container>
							<div className='row mt-3'>
								<div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
									<SideMenuComponent />
								</div>
								<div className='col-xs-12 col-sm-12 col-md-8 col-lg-8'>
									<Card className='p-2'>
										<Card.Title className='p-2' style={{ fontWeight: 'bold' }}>Last Login</Card.Title>
										<Card.Body className="centered-form">
											<Row style={{ border: '1px solid silver', padding: '8px' }}>
												<Col>Logged Timestamp : {last_login.activity_timestamp}</Col>
											</Row>
											<Row style={{ border: '1px solid silver', padding: '8px' }}>
												<Col>Logged in IP : {last_login.ip_address} {last_login.platform}</Col>
											</Row>
											<Row style={{ border: '1px solid silver', padding: '8px' }}>
												<Col>Browser : {last_login.useragent}</Col>
											</Row>
										</Card.Body>
										<Card.Title className='p-2' style={{ fontWeight: 'bold' }}>Last Activities</Card.Title>
										<Accordion defaultActiveKey="0">
											{items.map(item =>
												<Accordion.Item eventKey={item.id} key={item.id}>
													<Accordion.Header>
														<div className="row" style={{ width: '100%' }}>
															<div className='col'>{item.activity}</div>
															<div className='col'>{item.activity_timestamp}</div>
														</div>
													</Accordion.Header>
													<Accordion.Body className='customTable'>
														{(item.result === 'FAIL') ?
															<Row style={{ color: 'red' }}>
																<Col>{item.activity}</Col>
																<Col>{item.ip_address}</Col>
																<Col>{item.useragent}</Col>
																<Col>{item.platform}</Col>
															</Row>
															: <Row style={{ color: 'green' }}>
																<Col>{item.activity}</Col>
																<Col>{item.ip_address}</Col>
																<Col>{item.useragent}</Col>
																<Col>{item.platform}</Col>
															</Row>}
													</Accordion.Body>
												</Accordion.Item>
											)}
										</Accordion>
									</Card>
								</div>
							</div>
						</Container>
					</div>
					<FooterComponent />
				</div>
			)
		};
	}
}
export default HomeComponent

